// JSON for the body of an inline <script>, whether the script runs
// (`window.user=…`) or carries data (application/ld+json).
// test/conventions/jsonForScript.unit.test.js fails on a bare JSON.stringify in
// dangerouslySetInnerHTML.
//
// JSON.stringify alone is not safe there. The HTML parser ends a script at
// the first "</script" it meets, even inside a JSON string, and "<!--" changes
// how it looks for that end, so a string value holding either (a user's name,
// say) closes the tag early and whatever follows is parsed as HTML, including
// a <script> of its own. Writing every "<" as the escape \u003c leaves no "<"
// in the script, and it parses back to the same string. U+2028 and U+2029 are
// allowed raw in JSON but ended the line inside a JavaScript string before
// ES2019, so older browsers throw on the script; escaped, every engine reads
// them.
//
// Undefined stays undefined, as JSON.stringify returns it: the error-boundary
// pages render the document with no env or user.
export function jsonForScript(value) {
  return JSON.stringify(value)
    ?.replace(/</g, "\\u003c")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
